module.exports = __webpack_public_path__ + "img/file-check.9a5b495f.svg";